import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import './BarcodeScanner.css';

interface BarcodeScannerProps {
  onScan: (code: string) => void;
  onClose: () => void;
}

export function BarcodeScanner({ onScan, onClose }: BarcodeScannerProps) {
  const scannerRef = useRef<Html5Qrcode | null>(null);
  const detectedRef = useRef(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const scannerId = 'barcode-reader';

    const scanner = new Html5Qrcode(scannerId);
    scannerRef.current = scanner;

    scanner.start(
      { facingMode: 'environment' },
      {
        fps: 10,
        qrbox: { width: 260, height: 100 },
      },
      (decodedText) => {
        if (!detectedRef.current) {
          detectedRef.current = true;
          scanner.stop().catch(() => {});
          onScan(decodedText);
        }
      },
      () => {},
    ).catch((err) => {
      setError(err?.message ?? 'Camera non disponible');
    });

    return () => {
      document.body.style.overflow = '';
      scanner.stop().catch(() => {});
    };
  }, [onScan]);

  return (
    <div className="scanner-overlay">
      <div className="scanner-header">
        <button className="scanner-close" onClick={() => {
          scannerRef.current?.stop().catch(() => {});
          onClose();
        }}>✕</button>
        <span>Scanner un code-barres</span>
        <div style={{ width: 32 }} />
      </div>

      <div className="scanner-viewport">
        <div id="barcode-reader" className="scanner-reader" />
      </div>

      {error && (
        <div className="scanner-fallback">
          <p>{error}</p>
        </div>
      )}

      <p className="scanner-hint">Placez le code-barres dans le cadre</p>
    </div>
  );
}
